import { ReactElement, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { useStickyHeader } from 'b2b-components/context/StickyHeaderContext';
import { Props } from '..';

export const Anchor = ({ className, componentData }: Props): ReactElement | null => {
  const location = useLocation();
  const { ref } = useStickyHeader();


  useEffect(() => {
    if (location.hash) {
      const anchorId = location.hash.replace('#', '');
      const element = document.getElementById(anchorId);
      const headerHeight = ref?.current ? ref.current.getBoundingClientRect().height : 0;

      if (element) {
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }
  }, [location.hash]);

  return (
    <div className={classNames('cds-cms-GridRow', className)} id={componentData.anchor_name}/>
  );
};
